import { render, staticRenderFns } from "./IconArchiveOutline.vue?vue&type=template&id=77cf311d"
import script from "./IconArchiveOutline.vue?vue&type=script&lang=js"
export * from "./IconArchiveOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports